// extracted by mini-css-extract-plugin
module.exports = {"greenDark":"#065471","greenLight":"#3292ab","gold":"#ffc045"};